var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "px-3 mt-4" },
        [_c("search", { on: { onSearch: _vm.onSearch } })],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.sales.rows,
            stripe: "",
            "default-sort": { prop: "UploadTime", order: "descending" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "mvm.AssetNo",
              label: "機台編號",
              width: "80",
              fixed: "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "GateNo", label: "倉道", width: "80" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "UploadTime",
              label: "交易時間",
              width: "180",
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("moment")(
                            scope.row.UploadTime,
                            "YYYY/MM/DD, HH:mm"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "ProductName", label: "品名" },
          }),
          _c("el-table-column", {
            attrs: { prop: "PayAmt", label: "金額", width: "80", sortable: "" },
          }),
          _c("el-table-column", {
            attrs: { prop: "invoice.Front", label: "發票號碼" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return scope.row.invoice
                      ? [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top-start",
                                title: _vm._f("invoiceFilter")(
                                  scope.row.invoice.detail.invoiceType
                                ),
                                width: "200",
                                trigger: "hover",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm._f("invoiceFilterClass")(
                                          scope.row.invoice.detail.invoiceType
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.invoice.Front) +
                                          _vm._s(scope.row.invoice.Number) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", { attrs: { prop: "CardNo", label: "卡號" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }